import { render, staticRenderFns } from "./tat.vue?vue&type=template&id=05f991e2&scoped=true"
import script from "./tat.vue?vue&type=script&lang=js"
export * from "./tat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05f991e2",
  null
  
)

export default component.exports